export function flatten<T>(values: T[][]) {
    return values.reduce((a, c) => a.concat(c), []);
}
